<template>
    <div class="col-md-12">
        <h3 class="text-center">Vos grilles d'audit</h3>
        <div id="grid-container-grille-audit-list">
            <div id="grilleAuditGrid__evolugrid_holder" style="position: relative">
                <div id="grilleAuditGrid">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>Thème</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="instance in userInstances" :key="instance.id">
                                <td><router-link :to="{name: 'Instance', params: {instanceId: instance.id}}">{{ instance.title }}</router-link></td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="pager"></div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        components: {
        },
        computed: {
            userInstances: function() {
                return this.$store.state.user.userInstances;
            }
        },
        methods: {
        },
        data: function()  {
            return {
            };
        }
    };
</script>

<style>


</style>
